import isPlainObject from 'lodash/isPlainObject'
import { Clearable } from '../models/Clearable'

export default function isEmptyValue(value: unknown): boolean {
  if (value instanceof Clearable) {
    return value.isEmpty()
  }

  if (Array.isArray(value)) {
    return value.length === 0
  }

  if (isPlainObject(value)) {
    return Object.values(value as Record<string, unknown>).every((v) => isEmptyValue(v))
  }

  return value === null || value === undefined || value === '' || value === false
}
